module.exports = __webpack_public_path__ + "static/media/more.f444cd55.svg";